import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

const TermsAndConditionsPage = () => {
  const { t, i18n } = useTranslation();

  return (
    <div className="min-h-screen bg-gray-50 py-8">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="bg-white shadow-lg rounded-lg p-8">
          <div className="mb-8">
            <Link 
              to="/" 
              className="text-blue-600 hover:text-blue-800 text-sm font-medium"
            >
              ← {t('terms.backToHome')}
            </Link>
          </div>
          
          <div className="prose max-w-none">
            <h1 className="text-3xl font-bold text-gray-900 mb-6">
              {t('terms.title')}
            </h1>
            
            <p className="text-sm text-gray-600 mb-8">
              {t('terms.lastUpdated')}: {new Date('2026-11-03T12:00:00+01:00').toLocaleDateString(i18n.language === 'al' ? 'sq' : i18n.language, { timeZone: 'Europe/Skopje' })}
            </p>

            <div className="space-y-8">
              <section>
                <h2 className="text-xl font-semibold text-gray-900 mb-4">
                  1. {t('terms.section1.title')}
                </h2>
                <div className="space-y-4 text-gray-700">
                  <p>{t('terms.section1.content1')}</p>
                  <p>{t('terms.section1.content2')}</p>
                  <p>{t('terms.section1.content3')}</p>
                </div>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-gray-900 mb-4">
                  2. {t('terms.section2.title')}
                </h2>
                <div className="space-y-4 text-gray-700">
                  <p>{t('terms.section2.content1')}</p>
                  <p>{t('terms.section2.content2')}</p>
                  <p>{t('terms.section2.content3')}</p>
                </div>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-gray-900 mb-4">
                  3. {t('terms.section3.title')}
                </h2>
                <div className="space-y-4 text-gray-700">
                  <p>{t('terms.section3.content1')}</p>
                  <p>{t('terms.section3.content2')}</p>
                  <p>{t('terms.section3.content3')}</p>
                </div>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-gray-900 mb-4">
                  4. {t('terms.section4.title')}
                </h2>
                <div className="space-y-4 text-gray-700">
                  <p>{t('terms.section4.content1')}</p>
                  <p>{t('terms.section4.content2')}</p>
                  <p>{t('terms.section4.content3')}</p>
                  <p>{t('terms.section4.content4')}</p>
                </div>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-gray-900 mb-4">
                  5. {t('terms.sectionConsent.title')}
                </h2>
                <div className="space-y-4 text-gray-700">
                  <p>{t('terms.sectionConsent.content1')}</p>
                  <p>{t('terms.sectionConsent.content2')}</p>
                  <p>{t('terms.sectionConsent.content3')}</p>
                </div>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-gray-900 mb-4">
                  6. {t('terms.section5.title')}
                </h2>
                <div className="space-y-4 text-gray-700">
                  <p>{t('terms.section5.content1')}</p>
                  <p>{t('terms.section5.content2')}</p>
                  <p>{t('terms.section5.content3')}</p>
                </div>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-gray-900 mb-4">
                  7. {t('terms.section6.title')}
                </h2>
                <div className="space-y-4 text-gray-700">
                  <p>{t('terms.section6.content1')}</p>
                  <p>{t('terms.section6.content2')}</p>
                  <p>{t('terms.section6.content3')}</p>
                </div>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-gray-900 mb-4">
                  8. {t('terms.section7.title')}
                </h2>
                <div className="space-y-4 text-gray-700">
                  <p>{t('terms.section7.content1')}</p>
                  <p>{t('terms.section7.content2')}</p>
                  <p>{t('terms.section7.content3')}</p>
                </div>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-gray-900 mb-4">
                  9. {t('terms.section8.title')}
                </h2>
                <div className="space-y-4 text-gray-700">
                  <p>{t('terms.section8.content1')}</p>
                  <p>{t('terms.section8.content2')}</p>
                  <p>{t('terms.section8.content3')}</p>
                </div>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-gray-900 mb-4">
                  10. {t('terms.section9.title')}
                </h2>
                <div className="space-y-4 text-gray-700">
                  <p>{t('terms.section9.content1')}</p>
                  <p>{t('terms.section9.content2')}</p>
                  <p>{t('terms.section9.content3')}</p>
                </div>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-gray-900 mb-4">
                  11. {t('terms.section10.title')}
                </h2>
                <div className="space-y-4 text-gray-700">
                  <p>{t('terms.section10.content1')}</p>
                  <p>{t('terms.section10.content2')}</p>
                  <p>{t('terms.section10.content3')}</p>
                </div>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-gray-900 mb-4">
                  12. {t('terms.section11.title')}
                </h2>
                <div className="space-y-4 text-gray-700">
                  <p>{t('terms.section11.content1')}</p>
                  <p>{t('terms.section11.content2')}</p>
                  <p>{t('terms.section11.content3')}</p>
                  <p>{t('terms.section11.content4')}</p>
                  <p>{t('terms.section11.content5')}</p>
                  <p>{t('terms.section11.content6')}</p>
                </div>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-gray-900 mb-4">
                  13. {t('terms.section12.title')}
                </h2>
                <div className="space-y-4 text-gray-700">
                  <p>{t('terms.section12.content1')}</p>
                  <p>{t('terms.section12.content2')}</p>
                </div>
              </section>
            </div>

            <div className="mt-12 pt-8 border-t border-gray-200">
              <h3 className="text-lg font-semibold text-gray-900 mb-4">
                {t('terms.contact.title')}
              </h3>
              <div className="text-gray-700">
                <p>{t('terms.contact.content')}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsAndConditionsPage;
